import { Component, Inject, PLATFORM_ID } from '@angular/core';
import {
  NavigationEnd,
  Router,
  Event as NavigationEvent,
  RouterModule,
} from '@angular/router';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'admin-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss'],
    imports: [CommonModule, RouterModule]
})
export class NavComponent {
  private currentRoute = 'home';

  constructor(
    router: Router
  ) {
    router.events
      .pipe(filter((e: NavigationEvent) => e instanceof NavigationEnd))
      .subscribe((e: NavigationEvent) => {
        const event = e as NavigationEnd;
        const url = event.urlAfterRedirects;
        this.currentRoute = url;
      });
  }

  isCurrentRoute(route: string): boolean {
    return this.currentRoute.indexOf(route) >= 0;
  }
}
